import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const sleepListSelector = createSelector(
  (state: RootState) => state.sleep.sleepList,
  (sleepList) => sleepList,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.sleep,
  (item) => item.nextToken !== '',
);

export const isInitSleepSelector = createSelector(
  (state: RootState) => state.sleep,
  (item) => item.nextToken !== null,
);
